<template>
    <header id="header-m">
        <div class="menu">
            <ul>
                <li  style="animation-delay: 0.1s"><a href="/index.html">{{$t('head').index}}</a></li>
                <li style="animation-delay: 0.2s"><a href="/about.html">{{$t('head').about[0]}}</a></li>
                <li style="animation-delay: 0.3s"><a href="/pro.html">{{$t('head').produce[0]}}</a></li>
                <li style="animation-delay: 0.4s"><a href="/job.html">{{$t('head').service[0]}}</a></li>
                <li style="animation-delay: 0.5s"><a href="/human.html">{{$t('human').joinus[0]}}</a></li>
                <li style="animation-delay: 0.6s"><a href="/news.html">{{$t('head').news[0]}}</a></li>
                <li style="animation-delay: 0.7s"><a href="/contact.html">{{$t('head').contact}}</a></li>
            </ul>
            <div class="lan" style="animation-delay: 0.7s">
                <span @click="changeLan('zh-CN')">CN</span>
                <span @click="changeLan('en')">EN</span>
            </div>
        </div>
    </header>
</template>

<script>
    import Scrollbar from 'smooth-scrollbar';
    import {setup} from "@/local";
    export default {
        data(){
            return{
            }
        },
        methods: {
          changeLan(n) {
            this.$i18n.locale = n;
            window.localStorage.setItem("language", n);
            setup(n);
            window.location.reload();
          },
        }
    }
</script>

<style scoped>
    header{
        position: fixed;
        left: 0;
        bottom: -60vh;
        width: 100vw;
        background-color: #EA5404;
        height:60vh;
        z-index: 10000;
        transition: all 600ms;
    }
    header  .menu ul li{
        padding: 15px 0;
        text-transform: uppercase;
        font-family: SourceHanSerifCN-Regular;
        opacity: 0;
        transition: all 1s;
    }
    header .menu ul li a{
        color:white;
        font-size: 12px;
    }
    header .menu .lan{
        width:100%;
        display: flex;
        flex-direction: row;
        justify-content: center;
    }
    header .menu .lan span{
        display: inline-block;
        width:20%;
        text-align: center;
        color:white;
        font-size: 12px;
    }
    header .menu ul{
        display: block;
        font-size: 18px;
        width:100%;
        padding: 18px 0px;
        text-align: center;
        list-style: none;
    }
    .show{
        bottom:0;
    }
    .show .menu ul li{
        animation: goShow forwards 1s linear;
        opacity: 1;
    }
    .show .menu .lan{
        animation: goShow forwards 1s linear;
        opacity: 1;
    }
    @keyframes goShow {
        from{
            opacity: 0;
        }
        to{
            opacity: 1;
        }
    }


</style>
